module.exports = __webpack_public_path__ + "static/media/liquidateswap.ba397342.jpeg";